// @flow

import type {RootState} from '../../../reducers/types';
import type {PerPage} from '../types';

import React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {Pagination as UIPagination} from '@xsolla/uikit';
import classNames from 'classnames/bind';
import {compose} from 'recompose';
import {changePage} from '../../../reducers/disputes/actions/table';
import {selectTableCurrentPage, selectTableRowsCount} from '../../../reducers/disputes/selectors';
import style from './style.css';

type Props = {
  +total: number,
  +current: {
    +value: number,
    +set: (number, string) => Promise<void>
  },
  +filterFormName: string
};

const cx = classNames.bind(style);
const stylePrefix = 'disputes-pagination';

const Pagination = ({total, current, filterFormName}: Props) => {
  const onChangePage = (page: number) => current.set(page, filterFormName);

  return (
    <div className={cx(stylePrefix)}>
      <UIPagination
        current={current.value}
        total={total}
        perPage={(100: PerPage)}
        onChangePage={onChangePage}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  total: selectTableRowsCount(state),
  current: selectTableCurrentPage(state)
});

const mapDispatchToProps = {
  changePage
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  total: stateProps.total,
  current: {
    value: stateProps.current,
    set: dispatchProps.changePage
  }
});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps, mergeProps), injectIntl);

export default enhance(Pagination);
